/** Phase 5G — SCR-MER-050–058 order board bindings (07-02) */

export const ORDER_BOARD_SCREEN_IDS = [
  'SCR-MER-050',
  'SCR-MER-051',
  'SCR-MER-052',
  'SCR-MER-053',
  'SCR-MER-054',
  'SCR-MER-055',
  'SCR-MER-056',
  'SCR-MER-057',
  'SCR-MER-058',
  'SCR-MER-090',
] as const;

export type OrderBoardScreenId = (typeof ORDER_BOARD_SCREEN_IDS)[number];

export const ORDER_BOARD_ROUTES: Record<OrderBoardScreenId, string> = {
  'SCR-MER-050': '/order-board',
  'SCR-MER-051': '/incoming-order',
  'SCR-MER-052': '/reject-order',
  'SCR-MER-053': '/order-detail-merchant',
  'SCR-MER-054': '/adjust-promised-time',
  'SCR-MER-055': '/order-history-merchant',
  'SCR-MER-056': '/cancel-order-merchant',
  'SCR-MER-057': '/courier-status',
  'SCR-MER-058': '/print-ticket',
  'SCR-MER-090': '/returned-order',
};

export const ORDER_BOARD_PERMISSIONS: Partial<Record<OrderBoardScreenId, readonly string[]>> = {
  'SCR-MER-050': ['PERM-order.order.list', 'PERM-order.scheduled.read'],
  'SCR-MER-051': ['PERM-order.order.accept'],
  'SCR-MER-052': ['PERM-order.order.reject'],
  'SCR-MER-053': ['PERM-order.order.read'],
  'SCR-MER-054': ['PERM-order.order.update-promisedtime'],
  'SCR-MER-055': ['PERM-order.order.list'],
  'SCR-MER-056': ['PERM-order.order.cancel'],
  'SCR-MER-057': ['PERM-delivery.job.read'],
  'SCR-MER-058': ['PERM-order.ticket.reprint'],
  'SCR-MER-090': [
    'PERM-fulfilment.handover.read',
    'PERM-inventory.stock.update',
    'PERM-dispute.dispute.create',
  ],
};

export const ORDER_BOARD_ENDPOINTS: Partial<Record<OrderBoardScreenId, readonly string[]>> = {
  'SCR-MER-050': [
    'GET /merchant/v1/orders/board',
    'GET /merchant/v1/orders',
    'GET /merchant/v1/orders/scheduled',
    'POST /merchant/v1/orders/scheduled/{id}/release',
  ],
  'SCR-MER-051': ['GET /merchant/v1/orders/{id}', 'POST /merchant/v1/orders/{id}/accept'],
  'SCR-MER-052': ['GET /merchant/v1/orders/{id}', 'POST /merchant/v1/orders/{id}/reject'],
  'SCR-MER-053': ['GET /merchant/v1/orders/{id}', 'GET /merchant/v1/orders/{id}/timeline'],
  'SCR-MER-054': ['GET /merchant/v1/orders/{id}', 'POST /merchant/v1/orders/{id}/adjust-prep-time'],
  'SCR-MER-055': ['GET /merchant/v1/orders', 'POST /merchant/v1/reports/exports'],
  'SCR-MER-056': ['GET /merchant/v1/orders/{id}', 'POST /merchant/v1/orders/{id}/cancel'],
  'SCR-MER-057': [
    'GET /merchant/v1/orders/{id}/delivery',
    'POST /merchant/v1/orders/{id}/delivery/report-issue',
  ],
  'SCR-MER-058': ['GET /merchant/v1/orders/{id}', 'POST /merchant/v1/orders/{id}/ticket/reprint'],
  'SCR-MER-090': [
    'GET /merchant/v1/orders/{id}',
    'POST /merchant/v1/orders/{id}/returned/confirm-receipt',
    'POST /merchant/v1/disputes',
    'GET /merchant/v1/orders/{id}/replacement',
    'POST /merchant/v1/orders/{id}/replacement',
    'PATCH /merchant/v1/branches/{id}/inventory/{itemId}',
  ],
};

/** Align with MOD-011 GET /orders?scope=history (includes COLLECTED/DELIVERED). */
export const MERCHANT_HISTORY_STATUSES = [
  'COMPLETED',
  'COLLECTED',
  'DELIVERED',
  'CANCELLED',
  'REJECTED',
  'EXPIRED',
  'PAYMENT_FAILED',
  'DELIVERY_FAILED',
] as const;

export const MERCHANT_HISTORY_LIMIT = 100;
export const MERCHANT_HISTORY_PAGE_SIZE = 10;
export const MERCHANT_HISTORY_PAGE_SIZES = [5, 10, 25, 50] as const;

export const ORDER_ID_STORAGE_KEY = 'beatq.merchant.orderId';

/** Aligns with MOD-011 REJECTION_REASONS */
export const REJECT_REASONS = [
  'OUT_OF_STOCK',
  'TOO_BUSY',
  'CLOSING_SOON',
  'OUTSIDE_DELIVERY_AREA',
  'ITEM_UNAVAILABLE',
  'EQUIPMENT_FAILURE',
  'PRICING_ERROR',
  'SUSPECTED_FRAUD',
  'OTHER',
] as const;

export const CANCEL_REASONS = [
  'CUSTOMER_REQUEST',
  'UNABLE_TO_FULFIL',
  'FRAUD_SUSPECTED',
  'OTHER',
] as const;

export const ADJUST_TIME_REASONS = [
  'KITCHEN_BUSY',
  'ITEM_TAKING_LONGER',
  'STAFF_SHORTAGE',
  'EQUIPMENT_ISSUE',
  'OTHER',
] as const;

export const MERCHANT_SUPPORT_MAILTO =
  'mailto:merchants@beatqeats.co.uk?subject=BeatQ%20Rider%20support';

export const MERCHANT_ORDER_SUPPORT_MAILTO =
  'mailto:merchants@beatqeats.co.uk?subject=BeatQ%20order%20support';
